import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';
import { ShipmentStatusMappingAdapter } from '../adapters/shipmentStatusMappingAdapter';
import type { ShipmentStatusMapping } from '../models/shipmentStatusMapping.types';

export const UNMAPPED_SHIPMENT_STATUS_MAPPINGS_KEY = ['shipment-status-mappings-unmapped'];

export const useUnmappedShipmentStatusMappings = (enabled: boolean) => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new ShipmentStatusMappingAdapter(httpClient);

  return useQuery({
    queryKey: UNMAPPED_SHIPMENT_STATUS_MAPPINGS_KEY,
    queryFn: async (): Promise<ShipmentStatusMapping[]> => {
      const all: ShipmentStatusMapping[] = [];
      let page = 1;
      let hasMore = true;

      while (hasMore) {
        const result = await adapter.fetchShipmentStatusMappingsPaginated({
          shipment_status_id: null,
          page,
          per_page: 100,
        });

        all.push(...result.mappings);
        hasMore = result.hasMore;
        page += 1;
      }

      return all;
    },
    enabled,
    staleTime: 0,
  });
};
